module.exports = __webpack_public_path__ + "img/graph1.24dd7253.png";